import { useMarkAllInboxNotificationsAsReadMutation } from '../../../__generated__/graphql';
import { useUserInfo } from '../../../context/UserInfo';

export const useMarkAllInboxNotificationsAsRead = () => {
  const { id: meId } = useUserInfo();

  return useMarkAllInboxNotificationsAsReadMutation({
    update: (cache, response) => {
      if (!response.data) {
        return;
      }
      const recordIdsModified =
        response.data.notifications.markAllInboxNotificationsAsRead.recordIds;
      if (!recordIdsModified || recordIdsModified.length === 0) {
        return;
      }

      const meCacheId: string | undefined = cache.identify({
        __typename: 'Me',
        Id: meId,
      });
      // uncache inbox notifications
      cache.evict({
        id: meCacheId,
        fieldName: 'inboxNotifications',
      });

      cache.gc();
    },
    optimisticResponse: () => {
      return {
        notifications: {
          markAllInboxNotificationsAsRead: {
            recordIds: [],
            __typename: 'AllNotificationsActionPayload',
          },
        },
      };
    },
  });
};
